import InfoIcon from '@mui/icons-material/Info'
import HelpIcon from '@mui/icons-material/Help'
import { AlertSeverityProps } from './_props'
import sxs from './_sxs'

export const severityProps: AlertSeverityProps = {
    INFO: {
        classes: {
            container: sxs.alertInfoContainer,
            element: sxs.alertInfo,
        },
        icon: <InfoIcon sx={[sxs.alertIcon, sxs.alertInfoIcon]} />,
        secondaryIcon: <HelpIcon sx={[sxs.alertSecondaryIcon, sxs.alertInfoIcon]} />,
    },
    WARNING: {
        classes: {
            container: sxs.alertWarningContainer,
            element: sxs.alertWarning,
        },
        icon: <InfoIcon sx={[sxs.alertIcon, sxs.alertWarningIcon]} />,
        secondaryIcon: <HelpIcon sx={[sxs.alertSecondaryIcon, sxs.alertWarningIcon]} />,
    },
}
